/*
 * Created by: cparaschiv
 * Date: 21.05.2014, 17:28 
 */

/*
* Helper for grid editing and dynamic columns.
*/

(function($, undefined) {
    'use strict';

    TS.ns('TS.widget');

    function getEditorType(type) {
        type = type != null ? type : "";
        if (type === 'defaultType') {
            type = 'text';
        }
        return type || "text";
    }

    function getEditorName(cfg, record) {
        return TS.unwrap(record[cfg.EditorNameProperty]) + '_Field';
    }

    function getCfg(cfg, record) {
        var editorType = getEditorType(cfg.type),
            editorName, dynCfg;

        if (cfg.IsDynamicColumn || editorType == 'dynamic') {
            editorName = getEditorName(cfg, record);
            dynCfg = cfg.listField.getEditor(editorName);
            if (dynCfg) {
                return dynCfg;
            } else {
                TS.Log.warn('Cannot find dynamic editor [' + editorName + '] for column [' + cfg.field + ']');
                return null;
            }
        }

        return cfg;
    }

    TS.widget.gridHelper = {
        getEditorType: getEditorType,
        getEditorName: getEditorName,
        getCfg: getCfg
    };

})(jQuery);